/**
 * Tiny tooltip wrapper for icon-only controls. Pairs a styled Radix tooltip with
 * any trigger element (the child must forward a ref / accept a `Slot`, e.g. a
 * `Button`, `DropdownMenuTrigger` or `Link`). Relies on the app-level
 * `TooltipProvider` mounted in `AppProviders`.
 */
import type * as React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@authe/ui-core";

export function Hint({
  label,
  side = "bottom",
  children,
}: {
  label: string;
  side?: "top" | "bottom" | "left" | "right";
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className="[overflow-wrap:anywhere]">{label}</TooltipContent>
    </Tooltip>
  );
}
